import React from 'react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/hero';
export function FinalCTA() {
  return <section aria-label="Tüm sistemi edinin" className="bg-obsidian text-white" data-id="element-74" data-mp="3udoz2oyozioy">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 text-center lg:grid-cols-2 lg:py-24 lg:text-left" style={{
      paddingTop: "23px",
      paddingBottom: "33px"
    }} data-id="element-75" data-mp="c7tw1mrnowv3">
        <div data-id="element-76" data-mp="m4f0o6zrk5ye">
          <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.92] sm:text-6xl" data-id="element-77" data-mp="m3wx0parupgg">
            Daha akıllı antrenman yap.
            <br data-id="element-78" data-mp="h3repzqe6fb1" />
            Daha iyi beslen.
            <br data-id="element-79" data-mp="vv1cdq4d0cbt" />
            <span className="text-electric" data-id="element-80" data-mp="vtgh1ya80pcw">Yarışa güvenle hazırlan.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-md text-lg text-white/70 lg:mx-0" data-id="element-81" data-mp="qwq25ea5jzt2">
            Antrenmandan bitiş çizgisine kadar tüm hazırlık sürecinizi tek bir sistem içerisinde organize edin.
          </p>
          <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-aqua" data-id="element-82" data-mp="zxefs7vmvy5f">Tüm sistemi edinin</p>
          <p className="mt-1 font-display text-5xl font-extrabold leading-none" data-id="element-83" data-mp="2c5y9pmy3ghdd">1.330 TRY</p>
          <p className="mt-2 text-sm font-semibold text-white/80" data-id="element-84" data-mp="2h4suuvjjai0n">UZUN MESAFE TRİATLON SİSTEMİ™ + 4 ÜCRETSİZ BONUS</p>
          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-85" data-mp="2m19htmezyqc5">
            <CTAButton data-id="element-86" data-mp="2r275geis0cl1">Sisteme şimdi erişin</CTAButton>
          </div>
          <p className="mt-3 text-xs text-white/50" data-id="element-87" data-mp="2v3sgdubr2gsl">Tek seferlik ödeme · 7 günlük para iade garantisi</p>
        </div>
        <img src={PRODUCT_IMAGE} alt="UZUN MESAFE TRİATLON SİSTEMİ™ ve dört bonus rehberi" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-[560px]" data-id="element-88" data-mp="3023syctfj5ei" />
      </div>
    </section>;
}